import { render, staticRenderFns } from "./journal-table-items-dialog.vue?vue&type=template&id=f36b3218&lang=pug&"
import script from "./journal-table-items-dialog.vue?vue&type=script&lang=ts&"
export * from "./journal-table-items-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports